module.exports = __webpack_public_path__ + "static/media/memphis-1.8def6f0c.png";